
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"51","height":"51","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"50","height":"50","rx":"25","fill":"#FFC13D"}}),_c('g',{attrs:{"clip-path":"url(#clip0_8365_38736)","fill":"#262626"}},[_c('path',{attrs:{"d":"M36.959 34.192H14.044a1.045 1.045 0 01-1.041-1.041V18.569c0-.573.468-1.042 1.041-1.042H36.96c.572 0 1.041.469 1.041 1.042V33.15c0 .573-.469 1.041-1.041 1.041zM15.085 32.11h20.83V19.61h-20.83v12.5z"}}),_c('path',{attrs:{"d":"M25.47 28.713a2.1 2.1 0 01-1.218-.396l-9.812-7.895a1.044 1.044 0 111.312-1.625l9.77 7.864 9.76-7.864a1.045 1.045 0 011.468.167 1.054 1.054 0 01-.166 1.468l-9.791 7.833a2.09 2.09 0 01-1.302.458l-.02-.01z"}}),_c('path',{attrs:{"d":"M14.044 34.192c-.27 0-.531-.104-.74-.302a1.037 1.037 0 010-1.468l7.292-7.291a1.037 1.037 0 111.468 1.468l-7.29 7.291a1.023 1.023 0 01-.74.302h.01zM36.959 34.192c-.271 0-.532-.104-.74-.302l-7.29-7.29a1.037 1.037 0 111.468-1.47l7.29 7.292a1.037 1.037 0 01-.739 1.77h.01z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_8365_38736"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(13 13.063)","d":"M0 0h25v25H0z"}})])])])
          )
        }
      }
    